import { Magic } from 'magic-sdk';
import { OAuthExtension } from '@magic-ext/oauth';
import mixpanel from 'mixpanel-browser';

import { getSubscriptionInfo } from './subscription';

export const m = new Magic(process.env.REACT_APP_MAGIC_API_KEY as string, {
  extensions: [new OAuthExtension()],
  locale: 'en_US',
});

export const checkUser = async (setUser: any) => {
  const isLoggedIn = await m.user.isLoggedIn();
  if (isLoggedIn) {
    const user = await m.user.getMetadata();

    if (user.email) {
      mixpanel.identify(user.email);
      const { hasPremium, subscriptionEnd, isNewSubscriber, isCanceled, plan, subscriptionAfterTrail } =
        await getSubscriptionInfo(user.email);

      return setUser({
        email: user.email,
        id: user.issuer,
        isNewSubscriber,
        hasPremium,
        subscriptionEnd,
        isCanceled,
        plan,
        subscriptionAfterTrail,
      });
    }
  }

  return setUser(null);
};

export const getRedirectResult = async (setUser: any) => {
  try {
    const user = await m.oauth.getRedirectResult();
    mixpanel.identify(user.magic.userMetadata.email as string);
    mixpanel.track('Login', { emailType: user.oauth.provider, email: user.magic.userMetadata.email });

    if (user.magic.userMetadata.email) {
      const { hasPremium, subscriptionEnd, isNewSubscriber, isCanceled, plan, subscriptionAfterTrail } =
        await getSubscriptionInfo(user.magic.userMetadata.email);

      setUser({
        email: user.magic.userMetadata.email,
        id: user.magic.userMetadata.issuer,
        isNewSubscriber,
        hasPremium,
        subscriptionEnd,
        isCanceled,
        plan,
        subscriptionAfterTrail,
      });
    }
  } catch (e) {
    setUser(null);
    // eslint-disable-next-line no-console
    console.log(e);
  }
};

export const login = async (email: string) => {
  try {
    await m.auth.loginWithMagicLink({ email });
    mixpanel.identify(email);
    mixpanel.track('Login', { email, emailType: 'email' });
  } catch (e) {
    throw new Error(e as string);
  }
};

export const loginWithGoogle = async () => {
  await m.oauth.loginWithRedirect({
    provider: 'google',
    redirectURI: `${window.location.href}/redirect-google`,
  });
};

export const loginWithApple = async () => {
  await m.oauth.loginWithRedirect({
    provider: 'apple',
    redirectURI: `${window.location.href}/redirect-apple`,
  });
};

export const logout = async (setUser: any) => {
  await m.user.logout();
  return setUser(null);
};
